import { render, staticRenderFns } from "./travelExpenses.vue?vue&type=template&id=1d7b8706&scoped=true&"
import script from "./travelExpenses.vue?vue&type=script&lang=js&"
export * from "./travelExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7b8706",
  null
  
)

export default component.exports